























































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AzureAdStatus } from "@/store/types";
import { User } from "@/store/authentication/types";
import i18n from "@/i18n";
import { FALLBACK_LOCALE } from "@/app.config";
import { bus } from "@/bus";
const namespace: string = "authentication";

@Component
export default class Login extends Vue {
    @Action("loginAction", { namespace }) loginAction: any;
    @Action("azureLoginAction", { namespace }) azureLoginAction: any;
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    @Getter("getAzureAdStatus") azureAdStatus!: AzureAdStatus;

    processingLogin = false;
    failedLogin = false;
    authUser: User = {
        email: "",
        password: ""
    };

    // azureAdStatus: AzureAdStatus = {
    //     enabled: false,
    //     loaded: false
    // };
    //
    // async mounted() {
    //     this.azureAdStatus = this.getAzureAdStatus;
    // }

    onLogin(): void {
        this.processingLogin = true;
        this.failedLogin = false;
        this.loginAction(this.authUser)
            .then((response: any) => {
                this.processingLogin = false;
                this.failedLogin = false;
                this.setLocale();
                this.$router.push("/");
            })
            .catch((reason: any) => {
                this.processingLogin = false;
                this.failedLogin = true;
                // TODO failed notification
                // alert("login failed");
            });
    }

    inputModified(): void {
        this.failedLogin = false;
    }

    setLocale(): void {
        const languageCode: string = this.getCurrentUser.cultureCode;
        i18n.locale = languageCode || FALLBACK_LOCALE;
    }

    onAzureSignIn() {
        this.azureLoginAction()
            .then((response: string) => {
                this.setLocale();
                this.$router.push("/");
            })
            .catch((reason: any) => {
                // TODO failed notification
            });
    }
}
